import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';

import { routes } from './app.routes';
import { credentialsInterceptor } from './shared/credentials.interceptor';
import { authErrorInterceptor } from './shared/auth-error.interceptor';
import { AuthService } from './shared/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([credentialsInterceptor, authErrorInterceptor]),
    ),
    // Verify the session cookie before the first route renders.
    provideAppInitializer(() => inject(AuthService).restoreSession()),
  ],
};
